/****************************************************
 * Module Name:  RevertMixBucketModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/

import React, { Component } from "react";
import MixBucketProxy from "../../utility/proxy/manager/mixProxy/mixBucketProxy";
import Constants from "../../utility/constants";
import { DataGridPro, GridToolbar } from "@mui/x-data-grid-pro";
import Utility from "../../utility/utility";
import { Box, Button, CircularProgress, styled, Tooltip } from "@mui/material";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import CommonSnackbar from "../common/commonSnackBar";
import { Modal } from "react-bootstrap";
import logo from '../../images/pansuriya.jpg';
import CommonStoneSelection from "../common/commonStoneSelection";
import renderCellExpand from "../common/dataGridCellExpand";
import { LoadingButton } from "@mui/lab";
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import StoneDetailModal from "../common/stoneDetailModal";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import Papa from 'papaparse';
import { BackupTable } from "@mui/icons-material";
import BucketDetailModal from "../mixDiamondSales/bucketDetailModal";
import KapanHistoryModal from "../manufacturing/operations/kapanHistoryModal";


const StyledDataGrid = styled(DataGridPro)(({ theme }) => ({
    "& .super-app-theme--AVAILABLE": {
        color: "#000",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            color: "#000",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--HOLD": {
        backgroundColor: "#b6b9d6",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        color: "#000",
        "&:hover": {
            backgroundColor: "#b6b9d6",
            color: "#000",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--SELL": {
        backgroundColor: "#f5d7d7",
        color: "#080808",
        "&:hover": {
            backgroundColor: "#f5d7d7",
            color: "#080808",
        },
    },
    '& .MuiDataGrid-columnHeader': {
        color: '#fff',
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        backgroundColor: 'grey',
    },
    "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
        py: "8px",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
    },
    "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
        py: "15px",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
    },
    "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
        py: "22px",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
    },

}));

export default class RevertMixBucketModal extends Component {
    constructor(props) {
        super(props);

        this.state = {

            stones: [],
            stockLoader: false,
            sortModel: [],
            stoneid: "",
            selectionModel: [],
            showStoneDetailModal: false,

            showSnackbar: false,
            showSnackbarMsg: "",
            snackbarVariant: "",

            uploadLoader: false,
            alertSnackbar: false,
            alertMessage: "",

            showBucketDetailModal: false,
            bucketId: [],
            showKapanDetailModal: false,
            kapanId: [],
        };

        if (this.props.reactivateByStone)
            this.getAllStoneByBucketId();
    }

    removeStonesFromBucket = () => {
        if (this.props.handleRemove) {
            if (this.props.handleValidation) {
                if (this.props.handleValidation(this.props.sourceData.id))
                    this.props.handleRemove(this.state.selectionModel, this.props.sourceData.id);
                else
                    this.setState({
                        showError: true,
                    });
            } else this.props.handleRemove(this.state.selectionModel, this.props.sourceData.id);
        }
    };

    removeStonesFromBucketBulk = () => {
        if (this.props.handleBulkRemove) {
            let data = [];
            let invalidData = [];
            this.state.stones.forEach(iStones => {
                if (this.state.selectionModel.includes(iStones.srNo)) {
                    if (!iStones.stonetype || !iStones.size || !iStones.shape || !iStones.color || !iStones.clarity ||
                        !iStones.suratid || !iStones.cut || !iStones.pol || !iStones.sym || !iStones.flo) {
                        invalidData.push(iStones);
                    } else {
                        data.push(iStones);
                    }
                }
            })

            if (invalidData.length > 0) {
                this.setState({
                    showSnackbar: true,
                    showSnackbarMsg: "Incomplete Data. Please fill all the fields.",
                    snackbarVariant: "warning",
                })
            } else {
                if (this.props.handleValidation) {
                    if (this.props.handleValidation(this.props.sourceData.id))
                        this.props.handleBulkRemove(data, this.props.sourceData.id);
                    else
                        this.setState({
                            showError: true,
                        });
                } else {
                    this.props.handleBulkRemove(data, this.props.sourceData.id);
                }
            }
        }
    };

    getAllStoneByBucketId = () => {
        this.setState({ stockLoader: true });
        MixBucketProxy.GetAllStonesByBucketId(this.props.sourceData.id, (response => {
            if (response) {
                this.setState({ stones: response, stockLoader: false });
            } else {
                this.setState({
                    showSnackbar: true,
                    showSnackbarMsg: Constants.APiFailErrorMessage,
                    snackbarVariant: "error",
                    stockLoader: false
                });
            }
        }));
    }

    handleStoneDetailModal = (params) => {
        this.setState({
            stoneid: params.value,
            showStoneDetailModal: true
        });
    };

    handleSelection = (data) => {
        const [tempStockData, tempSelectionModel] = Utility.handleSelection(data, this.state.stones, this.state.selectionModel);

        this.setState({
            stones: tempStockData,
            selectionModel: tempSelectionModel
        });
    }

    handleBucketDetailModal = (params) => {
        this.setState({ showBucketDetailModal: true, bucketId: params.value });
    };

    hideBucketDetailModal = () => {
        this.setState({
            showBucketDetailModal: false,
        });
    };

    handleUpload = (file) => {
        this.setState({ uploadLoader: true });

        const reader = new FileReader();

        reader.onload = () => {
            const text = reader.result;
            Papa.parse(text, {
                header: true,
                skipEmptyLines: true,
                complete: (result) => {
                    if (result.data.length <= 0) {
                        this.setState({
                            alertSnackbar: true,
                            alertMessage: "No Stones Found"
                        });
                        return;
                    }

                    let headersFromCSV = Object.keys(result.data[0]);
                    let requiredColumns = ["Sr.No.", "Packet No.", "Pcs", "L.NO.", "STONE. ID", "SIZE", "SHAPE", "COLOR", "CLARITY", "RATE", "DI.", "PR.CT.$", "TOTAL", "CUT", "POL", "SYM", "FLO", "DIAM"];
                    if (headersFromCSV.length === requiredColumns.length) {

                        let stonelist = [];
                        let stoneIds = [];
                        result.data.forEach((record, index) => {
                            let row = {
                                srNo: index + 1,
                                packetid: record['Packet No.'] || "",
                                kapanid: parseInt(record['L.NO.']),
                                suratid: record['STONE. ID'],
                                size: parseFloat(record['SIZE']),
                                shape: record['SHAPE'] || "",
                                color: record['COLOR'] || "",
                                clarity: record['CLARITY'] || "",
                                rapnetprice: parseFloat(record['RATE']),
                                discount: parseFloat(record['DI.']),
                                price: parseFloat(record['PR.CT.$']),
                                total: parseFloat(record['TOTAL']),
                                cut: record['CUT'] || "",
                                pol: record['POL'] || "",
                                sym: record['SYM'] || "",
                                flo: record['FLO'] || "",
                                length: record['DIAM'] || "",
                                status: "NEW",
                                stonetype: this.props.sourceData.stonetypename
                            };
                            stonelist.push(row);
                            stoneIds.push(index + 1);
                            return true;
                        });

                        this.setState({
                            stones: stonelist,
                            selectionModel: stoneIds,
                            uploadLoader: false,
                            uploadSuccessSnackbar: true
                        });
                    } else {
                        console.error('CSV columns do not match table columns.');
                        this.setState({
                            uploadLoader: false,
                            uploadSuccessSnackbar: true
                        });
                    }
                },
                error: (error) => {
                    console.error('Error parsing CSV:', error);
                    this.setState({
                        alertSnackbar: true,
                        uploadLoader: false
                    });
                }
            });
        };
        reader.readAsText(file);
    };

    handleClear = () => {
        const fileInput = document.getElementById('file-input');
        fileInput.value = null;
    }

    render() {

        const columns = [
            {
                field: "srNo",
                headerName: "SR. NO.",
                headerAlign: "center",
                align: "center",
                type: "number",
                valueFormatter: (params) => params.value,
                width: 80
            },
            {
                field: "stoneid",
                headerName: "STONEID",
                pinning: { position: 'left' },
                headerAlign: "center",
                align: "center",
                width: 80,
                cellClassName: 'stickyColumn',
                type: "number",
                valueFormatter: (params) => params.value,
                renderCell: (params) => Utility.NeedToShowStoneDetailModal() ?
                    <Button
                        sx={{
                            textDecorationLine: "underline",
                            color: 'black'
                        }}
                        onClick={() => this.handleStoneDetailModal(params)}
                    >
                        {params.value}
                    </Button>
                    :
                    <div>{params.value}</div>,
            },
            {
                field: "suratid",
                headerName: "SURATID",
                headerAlign: "center",
                align: "center",
                width: 80
            },
            {
                field: "bucketid",
                headerName: "BUCKETID",
                headerAlign: "center",
                align: "center",
                type: "number",
                valueFormatter: (params) => params.value,
                renderCell: (params) => (Utility.NeedToShowBucketDetailModal()) ?
                    <Button
                        sx={{
                            textDecorationLine: "underline",
                            color: 'black'
                        }}
                        onClick={() => this.handleBucketDetailModal(params)}
                    >
                        {params.value}
                    </Button>
                    :
                    <div>{params.value}</div>,
                width: 80
            },
            {
                field: "kapanid",
                headerName: "KAPANID",
                headerAlign: "center",
                align: "center",
                type: "number",
                valueFormatter: (params) => params.value,
                renderCell: (params) => (Utility.NeedToShowKapanDetailModal()) ?
                    <Button
                        sx={{
                            textDecorationLine: "underline",
                            color: 'black',
                        }}
                        onClick={() => {
                            this.setState({ kapanId: params.row.kapanid, showKapanDetailModal: true })
                        }}
                    >
                        {params.value}
                    </Button>
                    :
                    <div>{params.value}</div>,
                width: 80,
            },
            {
                field: "stonetype",
                headerName: "STONETYPE",
                headerAlign: "center",
                align: "center",
                width: 100,
                type: "singleSelect",
                valueOptions: Constants.uniqueFilterValues.stonetype.map(option => option.fullname),
                filterOperators: Utility.combinedFilters(),
                valueGetter: (params) => Constants.STONE_TYPE[params.value],
                renderCell: (params) => Constants.STONE_TYPE[params.value],
            },
            {
                field: "status",
                headerName: "STATUS",
                headerAlign: "center",
                align: "center",
                width: 100,
                renderCell: renderCellExpand,
                cellClassName: (params) => `super-app-theme--${params.row.status.toUpperCase()}`,
            },
            {
                field: "shape",
                headerName: "SHAPE",
                headerAlign: "center",
                align: "center",
                width: 80,
                type: "singleSelect",
                valueOptions: Constants.uniqueFilterValues.shape.sort((a, b) => a.seq - b.seq).map(option => option.value),
                filterOperators: Utility.combinedFilters(),
                renderCell: renderCellExpand,
            },
            {
                field: "size",
                headerName: "SIZE",
                headerAlign: "center",
                width: 40,
                align: "right",
                type: "number",
                valueFormatter: (params) => params.value,
                renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.size)
            },
            {
                field: "color",
                headerName: "COLOR",
                headerAlign: "center",
                align: "center",
                width: 65,
                type: "singleSelect",
                valueOptions: Constants.uniqueFilterValues.color.sort((a, b) => a.seq - b.seq).map(option => option.value),
                filterOperators: Utility.combinedFilters(),
                renderCell: renderCellExpand,
            },
            {
                field: "clarity",
                headerName: "CLARITY",
                headerAlign: "center",
                align: "center",
                width: 75,
                type: "singleSelect",
                valueOptions: Constants.uniqueFilterValues.clarity.sort((a, b) => a.seq - b.seq).map(option => option.value),
                filterOperators: Utility.combinedFilters(),
                renderCell: renderCellExpand,
            },
            {
                field: "cut",
                headerName: "CUT",
                headerAlign: "center",
                align: "center",
                width: 50,
                type: "singleSelect",
                valueOptions: Constants.uniqueFilterValues.cut.sort((a, b) => a.seq - b.seq).map(option => option.value),
                filterOperators: Utility.combinedFilters(),
                renderCell: renderCellExpand,
            },
            {
                field: "pol",
                headerName: "POL",
                headerAlign: "center",
                align: "center",
                width: 40,
                type: "singleSelect",
                valueOptions: Constants.uniqueFilterValues.pol.sort((a, b) => a.seq - b.seq).map(option => option.value),
                filterOperators: Utility.combinedFilters(),
                renderCell: renderCellExpand,
            },
            {
                field: "sym",
                headerName: "SYM",
                headerAlign: "center",
                align: "center",
                width: 40,
                type: "singleSelect",
                valueOptions: Constants.uniqueFilterValues.sym.sort((a, b) => a.seq - b.seq).map(option => option.value),
                filterOperators: Utility.combinedFilters(),
                renderCell: renderCellExpand,
            },
            {
                field: "flo",
                headerName: "FLO",
                headerAlign: "center",
                align: "center",
                width: 60,
                type: "singleSelect",
                valueOptions: Constants.uniqueFilterValues.flo.sort((a, b) => a.seq - b.seq).map(option => option.value),
                filterOperators: Utility.combinedFilters(),
                renderCell: renderCellExpand,
            },
            {
                field: "discount",
                headerName: "DIS",
                headerAlign: "center",
                align: "right",
                width: 50,
                type: "number",
                valueFormatter: (params) => params.value,
                renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.discount)
            },
            {
                field: "rapnetprice",
                headerName: "RAP",
                headerAlign: "center",
                align: "right",
                width: 70,
                type: "number",
                valueFormatter: (params) => params.value,
                renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.rapnetprice)
            },
            {
                field: "price",
                headerName: "PPC",
                headerAlign: "center",
                align: "right",
                width: 70,
                type: "number",
                valueFormatter: (params) => params.value,
                renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.price)
            },
            {
                field: "total",
                headerName: "TOTAL",
                headerAlign: "center",
                align: "right",
                type: "number",
                valueFormatter: (params) => params.value,
                width: 70,
                renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.total)
            },
            {
                field: "measurements",
                headerName: "MEASUREMENTS",
                headerAlign: "center",
                align: "center",
                width: 140,
                renderCell: renderCellExpand,
            },
            {
                field: "depth",
                headerName: "DEPTH",
                headerAlign: "center",
                align: "center",
                width: 70,
                type: "number",
                valueFormatter: (params) => params.value,
                renderCell: renderCellExpand,
            },
            {
                field: "lab",
                headerName: "LAB",
                headerAlign: "center",
                align: "center",
                width: 40,
                type: "singleSelect",
                valueOptions: Constants.uniqueFilterValues.lab.sort((a, b) => a.seq - b.seq).map(option => option.value),
                filterOperators: Utility.combinedFilters(),
                renderCell: renderCellExpand,
            },
            {
                field: "locationid",
                headerName: "LOCATION",
                headerAlign: "center",
                align: "center",
                type: "number",
                valueFormatter: (params) => params.value,
                renderCell: renderCellExpand,
            },
            {
                field: "location",
                headerName: "LOCATION",
                headerAlign: "center",
                align: "center",
                width: 100,
                type: "singleSelect",
                valueOptions: Constants.uniqueFilterValues.location.sort((a, b) => a.seq - b.seq).map(option => option.value),
                filterOperators: Utility.combinedFilters(),
                renderCell: renderCellExpand,
            },
            {
                field: "country",
                headerName: "COUNTRY",
                headerAlign: "center",
                align: "center",
                renderCell: renderCellExpand,
            },
            {
                field: "quality",
                headerName: "QUALITY",
                headerAlign: "center",
                align: "center",
                width: 80,
                renderCell: renderCellExpand,
            },
            {
                field: "shade",
                headerName: "SHADE",
                headerAlign: "center",
                align: "center",
                width: 60,
                renderCell: renderCellExpand,
            },
            {
                field: "createdat",
                headerName: "CREATED AT",
                headerAlign: "center",
                align: "center",
                type: "dateTime",
                valueGetter: (params) => {
                    if (params.value) {
                        return new Date(params.value);
                    }
                    return null;
                },
                renderCell: (params) => Utility.ConvertUtcToLocalTime(params.value),
            },
            {
                field: "height",
                headerName: "HEIGHT",
                headerAlign: "center",
                align: "center",
                width: 70,
                type: "number",
                valueFormatter: (params) => params.value,
                renderCell: renderCellExpand,
            },
            {
                field: "width",
                headerName: "WIDTH",
                headerAlign: "center",
                align: "center",
                width: 70,
                type: "number",
                valueFormatter: (params) => params.value,
                renderCell: renderCellExpand,
            },
            {
                field: "certificateid",
                headerName: "CERT",
                headerAlign: "center",
                align: "center",
                width: 100,
                renderCell: renderCellExpand,
            },
            {
                field: "fancycolour",
                headerName: "F.COLOR",
                headerAlign: "center",
                align: "center",
                renderCell: renderCellExpand,
            },
            {
                field: "fancycolorovertone",
                headerName: "OVERTONE",
                headerAlign: "center",
                align: "center",
                width: 120,
                renderCell: renderCellExpand,
            },
            {
                field: "fancycolorintensity",
                headerName: "F.COL.INTENSITY",
                headerAlign: "center",
                align: "center",
                width: 140,
                renderCell: renderCellExpand,
            },
            {
                field: "comment",
                headerName: "COMMENT",
                headerAlign: "center",
                align: "center",
                renderCell: renderCellExpand,
            },
            {
                field: "crownheight",
                headerName: "CR.HEIGHT",
                headerAlign: "center",
                align: "center",
                type: "number",
                valueFormatter: (params) => params.value,
                renderCell: renderCellExpand,
            },
            {
                field: "crownangle",
                headerName: "CR.ANG",
                headerAlign: "center",
                align: "center",
                type: "number",
                valueFormatter: (params) => params.value,
                renderCell: renderCellExpand,
            },
            {
                field: "culetsize",
                headerName: "CULET SZ",
                headerAlign: "center",
                align: "center",
                type: "number",
                valueFormatter: (params) => params.value,
                renderCell: renderCellExpand,
            },
            {
                field: "culetcondition",
                headerName: "CULET",
                headerAlign: "center",
                align: "center",
                renderCell: renderCellExpand,
            },
            {
                field: "depthpercent",
                headerName: "DEPTH%",
                headerAlign: "center",
                align: "center",
                width: 75,
                type: "number",
                valueFormatter: (params) => params.value,
                renderCell: renderCellExpand,
            },
            {
                field: "gridlemin",
                headerName: "GIRDLEMIN",
                headerAlign: "center",
                align: "center",
                renderCell: renderCellExpand,
            },
            {
                field: "intensitylongtitle",
                headerName: "INTENSITYLONGTITLE",
                headerAlign: "center",
                align: "center",
                renderCell: renderCellExpand,
            },
            {
                field: "laserinscription",
                headerName: "INS",
                headerAlign: "center",
                align: "center",
                renderCell: renderCellExpand,
            },
            {
                field: "note",
                headerName: "NOTE",
                headerAlign: "center",
                align: "center",
                renderCell: renderCellExpand,
            },
            {
                field: "paviliondepth",
                headerName: "PV.DEPTH",
                headerAlign: "center",
                align: "center",
                type: "number",
                valueFormatter: (params) => params.value,
                renderCell: renderCellExpand,
            },
            {
                field: "tablepercent",
                headerName: "TABLE%",
                headerAlign: "center",
                align: "center",
                width: 75,
                type: "number",
                valueFormatter: (params) => params.value,
                renderCell: renderCellExpand,
            },
            {
                field: "open",
                headerName: "OPEN",
                headerAlign: "center",
                align: "center",
                renderCell: renderCellExpand,
            },
            {
                field: "gridlecondition",
                headerName: "GIRDLE COND",
                headerAlign: "center",
                align: "center",
                renderCell: renderCellExpand,
            },
            {
                field: "gridlepercent",
                headerName: "GIRDLE%",
                headerAlign: "center",
                align: "center",
                type: "number",
                valueFormatter: (params) => params.value,
                renderCell: renderCellExpand,
            },
            {
                field: "pavilionangle",
                headerName: "PV.ANGLE",
                headerAlign: "center",
                align: "center",
                type: "number",
                valueFormatter: (params) => params.value,
                renderCell: renderCellExpand,
            },
            {
                field: "white",
                headerName: "WHITE",
                headerAlign: "center",
                align: "center",
                renderCell: renderCellExpand,
            },
            {
                field: "avgrapnetprice",
                headerName: "AVG RAP PRICE",
                headerAlign: "center",
                width: 140,
                align: "center",
                type: "number",
                valueFormatter: (params) => params.value,
                renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.value),
            },
            {
                field: "avgdiscount",
                headerName: "AVG DIS",
                headerAlign: "center",
                align: "center",
                type: "number",
                valueFormatter: (params) => params.value,
                renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.value),
            },
            {
                field: "avgprice",
                headerName: "AVG PRICE",
                headerAlign: "center",
                align: "center",
                type: "number",
                valueFormatter: (params) => params.value,
                renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.value),
            },
            {
                field: "avgtotal",
                headerName: "AVG TOTAL",
                headerAlign: "center",
                align: "center",
                type: "number",
                valueFormatter: (params) => params.value,
                renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.value),
            },
            {
                field: "age",
                headerName: "AGE",
                headerAlign: "center",
                align: "center",
                valueGetter: (params) => {
                    if (params.value)
                        return Utility.ConvertDateToAge(params.value);
                    else
                        return null;
                },
                renderCell: (params) => {
                    return params.value;
                },
            },
            {
                field: "tableinc",
                headerName: "TABLE INC",
                headerAlign: "center",
                align: "center",
                width: 120,
            },
            {
                field: "sideinc",
                headerName: "SIDE INC",
                headerAlign: "center",
                align: "center",
                width: 120,
            },
            {
                field: "h_and_a",
                headerName: "H&A",
                headerAlign: "center",
                align: "center",
                width: 120,
            },
            {
                field: "eyeclean",
                headerName: "EYE CLEAN",
                headerAlign: "center",
                align: "center",
                width: 120,
            },
            {
                field: "tinge",
                headerName: "TINGE",
                headerAlign: "center",
                align: "center",
                type: "singleSelect",
                valueOptions: Constants.uniqueFilterValues.tinge.sort((a, b) => a.seq - b.seq).map(option => option.value),
                filterOperators: Utility.combinedFilters(),
                width: 120,
            },
            {
                field: "milky",
                headerName: "MILKY",
                headerAlign: "center",
                align: "center",
                type: "singleSelect",
                valueOptions: Constants.uniqueFilterValues.milky.sort((a, b) => a.seq - b.seq).map(option => option.value),
                filterOperators: Utility.combinedFilters(),
                width: 120,
            },
            {
                field: "luster",
                headerName: "LUSTER",
                headerAlign: "center",
                align: "center",
                width: 120,
            },
            {
                field: "tableblack",
                headerName: "TABLE BLACK",
                headerAlign: "center",
                align: "center",
                type: "boolean",
                width: 120,
            },
            {
                field: "sideblack",
                headerName: "SIDE BLACK",
                headerAlign: "center",
                align: "center",
                type: "boolean",
                width: 120,
            }
        ];

        const columnNames = this.props.reactivateByStone ? columns.filter(iCol => iCol.field !== "srNo") :
            columns.filter(iCol =>
                ["srNo", "packetid", "kapanid", "suratid", "size", "shape", "color", "clarity", "rapnetprice",
                    "discount", "price", "total", "cut", "pol", "sym", "flo", "length", "stonetype"]
                    .includes(iCol.field)
            )

        return (
            <Box sx={{ "& .bhb": { height: "80vh" } }}>
                <Modal backdrop="static" show={this.props.show} onHide={this.props.handleClose} dialogClassName="bhb" enforceFocus={false}>

                    <CommonSnackbar
                        show={this.state.alertSnackbar}
                        message={this.state.alertMessage}
                        variant={"error"}
                        autoHide={false}
                        title={"Error"}
                        handleClose={() => this.setState({ alertSnackbar: false })}
                    />

                    <CommonSnackbar
                        show={this.state.showSnackbar}
                        message={this.state.showSnackbarMsg}
                        variant={this.state.snackbarVariant}
                        autoHide={Constants.SnackBarCloseTimer}
                        handleClose={() => this.setState({ showSnackbar: false })}
                        title={this.state.snackbarVariant === "success" ? "Success" :
                            (this.state.snackbarVariant === "error" ? "Failed" : "Warning")}
                    />

                    {this.state.stones ? (
                        <CommonSnackbar
                            show={this.state.uploadSuccessSnackbar}
                            message={
                                this.state.stones.length !== 0
                                    ? (this.state.selectionModel.length <= 0 ? `Please correct your data and retry again` : `File loaded Successfully`)
                                    : `File could not be loaded. Please correct your data and retry again`
                            }
                            variant={this.state.stones.length !== 0 && this.state.selectionModel.length > 0 ? "success" : "error"}
                            autoHide={true}
                            title={this.state.stones.length !== 0 && this.state.selectionModel.length > 0 ? "Success" : "Failed"}
                            handleClose={() => this.setState({ uploadSuccessSnackbar: false })}
                        />
                    ) : null}

                    {this.state.showStoneDetailModal ? (
                        <StoneDetailModal
                            show={this.state.showStoneDetailModal}
                            stoneId={this.state.stoneid}
                            handleClose={() => this.setState({ showStoneDetailModal: false })}
                        />
                    ) : null}

                    {this.state.showKapanDetailModal ? (
                        <KapanHistoryModal
                            show={this.state.showKapanDetailModal}
                            kapanId={this.state.kapanId}
                            close={() => this.setState({ showKapanDetailModal: false })}
                        />
                    ) : null}

                    {this.state.showBucketDetailModal ? (
                        <BucketDetailModal
                            show={this.state.showBucketDetailModal}
                            bucketId={this.state.bucketId}
                            handleClose={this.hideBucketDetailModal}
                        />
                    ) : null}

                    <Modal.Header closeButton>
                        <Modal.Title>
                            <img
                                src={logo}
                                height="40pt"
                                width="40pt"
                                alt={Constants.COMPANY_SITE}
                            />
                            &nbsp;&nbsp; Revert Mix Bucket ({this.props.reactivateByStone ? "Stones" : "Excel"})
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Box
                            sx={{
                                backgroundColor: '#fff',
                                color: '#000',
                                width: "100%",
                                position: "relative",
                                "& .MuiTablePagination-selectLabel": {
                                    marginTop: "15px",
                                },
                                "& .MuiTablePagination-displayedRows": {
                                    marginTop: "15px",
                                },
                                "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                                    fontWeight: Constants.defaultFontWeight,
                                },
                                "& .css-cc8tf1": {
                                    fontWeight: Constants.defaultFontWeight,
                                },
                                height: '70vh',
                                "& .lavenderCell": {
                                    color: "#080808",
                                    backgroundColor: "#D8BFD8",
                                },
                            }}
                        >
                            <StyledDataGrid
                                disableRowSelectionOnClick={true}
                                localeText={{ noRowsLabel: "No Record Found" }}
                                sx={{ height: "70vh", fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight, }}
                                slots={{
                                    toolbar: GridToolbar,
                                }}
                                rows={this.state.stones}
                                sortModel={this.state.sortModel}
                                onSortModelChange={(newModel) => this.setState({ sortModel: newModel })}
                                density="compact"
                                columns={columnNames}
                                getRowId={(row) => this.props.reactivateByStone ? row.stoneid : row.srNo}
                                checkboxSelection={true}
                                onRowSelectionModelChange={(newSelectionModel) => this.setState({ selectionModel: newSelectionModel })}
                                loading={this.state.stockLoader}
                                rowSelectionModel={this.state.selectionModel}
                                initialState={{
                                    columns: {
                                        columnVisibilityModel: {
                                            // Hide columns id, the other columns will remain visible
                                            locationid: false,
                                            kapanid: false,
                                            country: false,
                                            quality: false,
                                            shade: false,
                                            repacode: false,
                                            createdat: false,
                                            height: false,
                                            width: false,
                                            packetid: false,
                                            crownheight: false,
                                            crownangle: false,
                                            culetsize: false,
                                            culetcondition: false,
                                            depthpercent: false,
                                            gridlemin: false,
                                            intensitylongtitle: false,
                                            laserinscription: false,
                                            note: false,
                                            paviliondepth: false,
                                            gridlecondition: false,
                                            gridlepercent: false,
                                            pavilionangle: false,
                                            white: false,
                                            location: false,
                                            comment: false,
                                            tablepercent: false,
                                            open: false,
                                            avgrapnetprice: false,
                                            avgdiscount: false,
                                            avgprice: false,
                                            avgtotal: false,
                                            tableinc: false,
                                            sideinc: false,
                                            milky: false,
                                            luster: false,
                                            h_and_a: false,
                                            eyeclean: false,
                                            tinge: false,
                                            tableblack: false,
                                            sideblack: false
                                        },
                                    },
                                    pagination: {
                                        paginationModel: Constants.pageSize,
                                    },
                                }}
                                pageSizeOptions={Constants.pageSizeOptions}
                                pagination
                                slotProps={{
                                    toolbar: {
                                        showQuickFilter: true,
                                        quickFilterProps: {
                                            debounceMs: 500,
                                        },
                                    },
                                }}
                            />

                            <Box sx={{
                                position: "absolute",
                                left: "0.4rem",
                                top: "1px"
                            }}>
                                <CommonStoneSelection title={"Enter multiple Stone Ids"} handleSelection={this.handleSelection} bgColor='#454545' buttonDisabled={this.state.stones.length === 0} />
                            </Box>

                            <Box
                                style={{
                                    position: "absolute",
                                    top: 6,
                                    right: "255px",
                                    display: "flex",
                                    marginRight: "10px"
                                }}
                            >

                                {this.state.stockLoader ? (
                                    <CircularProgress sx={{ cursor: "pointer", height: "1.8rem !important", width: "1.8rem !important" }} />
                                ) : (
                                    this.props.reactivateByStone ? (
                                        <Tooltip title="Reload List">
                                            <RefreshOutlinedIcon
                                                onClick={() => this.getAllStoneByBucketId()}
                                                color="primary"
                                                fontSize="large"
                                                sx={{ cursor: "pointer", height: "1.8rem", width: "1.8rem" }}
                                            />
                                        </Tooltip>
                                    ) : null
                                )}

                                {!this.props.reactivateByStone ? (
                                    <Box>
                                        <Tooltip title="Download Sample Reactivate Bulk Stones">
                                            <a
                                                href="/demo_excel/ReactivateBulkStone.csv"
                                                download="ReactivateBulkStone.csv"
                                                style={{ color: "red", marginRight: "10px", marginLeft: "10px" }}
                                            >
                                                <BackupTable size={25} />
                                            </a>
                                        </Tooltip>
                                        <Tooltip title="Upload stones to remove from bucket">
                                            <LoadingButton
                                                color="info"
                                                variant="outlined"
                                                size="small"
                                                sx={{ ml: "7px" }}
                                                component="label"
                                                loading={this.state.uploadLoader}
                                                loadingPosition="start"
                                                startIcon={<UploadFileIcon size="large" />}
                                                disabled={this.state.uploadLoader}
                                            >
                                                Upload
                                                <input
                                                    id="file-input"
                                                    hidden
                                                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                                    multiple
                                                    type="file"
                                                    onChange={(e) => {
                                                        this.setState({ uploadLoader: true });
                                                        this.handleUpload(e.target.files[0]);
                                                    }}
                                                    onClick={(e) => this.handleClear()}
                                                />
                                            </LoadingButton>
                                        </Tooltip>
                                    </Box>
                                ) : null}

                                <Tooltip title="Remove stones from bucket">
                                    <LoadingButton
                                        variant="contained"
                                        size="small"
                                        component="label"
                                        sx={{ ml: "7px" }}
                                        color="success"
                                        loading={this.props.loading}
                                        loadingPosition="start"
                                        startIcon={<RestartAltIcon />}
                                        disabled={this.state.selectionModel.length === 0}
                                        onClick={() => this.props.reactivateByStone ? this.removeStonesFromBucket() : this.removeStonesFromBucketBulk()}
                                    >
                                        RE-ACTIVATE
                                    </LoadingButton>
                                </Tooltip>
                            </Box>
                        </Box>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="contained" color="error" onClick={this.props.handleClose}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            </Box>
        );
    }
};